export default __webpack_public_path__ + "e2de5088838c48d5631245fe6e2d04bf.svg";